import { PaymentStatus } from "../enums/payment-status";
import { Payment } from "../models/Payment";
import { getPaymentStatus } from "./get-payment-status";

export function getPaymentStatusChangeDate(payment: Payment): Date | null {
    if (getPaymentStatus(payment).id === PaymentStatus.EXPIRED) {
        return payment.expiresAt;
    }

    if (getPaymentStatus(payment).id === PaymentStatus.PAID) {
        return payment.paidAt;
    }

    if (getPaymentStatus(payment).id === PaymentStatus.COMPLETE) {
        return payment.syncedToPmsAt;
    }

    if (getPaymentStatus(payment).id === PaymentStatus.REFUNDED) {
        return payment.refundedAt;
    }

    if (getPaymentStatus(payment).id === PaymentStatus.REFUND) {
        return payment.createdAt;
    }

    if (getPaymentStatus(payment).id === PaymentStatus.CANCELLED) {
        return payment.cancelledAt;
    }

    if (getPaymentStatus(payment).id === PaymentStatus.FUNDS_HELD) {
        return payment.authorisedAt ?? null;
    }

    if (getPaymentStatus(payment).id === PaymentStatus.HOLD_EXPIRED) {
        return payment.authorisationExpiresAt ?? null;
    }

    return null;
}
